import I18n from 'I18n';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import AnniversaryDateInput from './AnniversaryDateInput';
import styled from 'foundations-theming/utils';
import { useEffect } from 'react';
import { useElementSize } from '../../hooks/useElementSize';
import { INPUT_WIDTHS_EDITOR_CONDITION } from '../../constants/inlineLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DoublePanelAnniversaryRangeInputWrapper = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentAnniversary__DoublePanelAnniversaryRangeInputWrapper",
  componentId: "sc-1n2ha5r-0"
})(["display:flex;flex-direction:column;"]);
const SinglePanelAnniversaryRangeInputWrapper = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentAnniversary__SinglePanelAnniversaryRangeInputWrapper",
  componentId: "sc-1n2ha5r-1"
})(["display:flex;flex-direction:row;flex-wrap:wrap;gap:8px;justify-content:center;"]);
const SinglePanelAnniversaryDateInputWrapper = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentAnniversary__SinglePanelAnniversaryDateInputWrapper",
  componentId: "sc-1n2ha5r-2"
})(["min-width:", ";"], props => props.size === 'sm' ? '100%' : `${INPUT_WIDTHS_EDITOR_CONDITION[props.size]}px`);
const ToSeparator = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentAnniversary__ToSeparator",
  componentId: "sc-1n2ha5r-3"
})(["align-self:center;"]);
const getInitialAnniversaryRange = () => {
  const start = I18n.moment.portalTz();
  const end = I18n.moment.portalTz().add(1, 'months');
  const value = {
    month: start.month(),
    date: start.date()
  };
  const highValue = {
    month: end.month(),
    date: end.date(),
    offsetYear: end.year() > start.year()
  };
  return {
    value,
    highValue
  };
};
const getOffsetEndDateYear = ({
  endDate,
  startDate
}) => {
  const endDateIsBeforeStartDateSameMonth = (endDate === null || endDate === void 0 ? void 0 : endDate.month) === (startDate === null || startDate === void 0 ? void 0 : startDate.month) && typeof (endDate === null || endDate === void 0 ? void 0 : endDate.date) === 'number' && typeof (startDate === null || startDate === void 0 ? void 0 : startDate.date) === 'number' && endDate.date < startDate.date;
  const endMonthIsBeforeStartMonth = typeof (endDate === null || endDate === void 0 ? void 0 : endDate.month) === 'number' && typeof (startDate === null || startDate === void 0 ? void 0 : startDate.month) === 'number' && endDate.month < startDate.month;
  return endDateIsBeforeStartDateSameMonth || endMonthIsBeforeStartMonth;
};
const FilterOperatorDateRangeInputMomentAnniversary = props => {
  const {
    condition,
    error,
    onBlur,
    onChange,
    useOnePanel,
    inputUse
  } = props;
  const {
    width
  } = useElementSize();
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const startDate = condition.get('value');
  const endDate = condition.get('highValue');
  useEffect(() => {
    if (!startDate && !endDate) {
      const {
        value,
        highValue
      } = getInitialAnniversaryRange();
      onChange(syntheticEvent(condition.set('value', value).set('highValue', highValue)));
    }
  }, [condition, endDate, onChange, startDate]);
  const onChangeStartDate = newStartDate => {
    const updatedEndDate = Object.assign({}, endDate, {
      offsetYear: getOffsetEndDateYear({
        endDate,
        startDate: newStartDate
      })
    });
    onChange(syntheticEvent(condition.set('value', newStartDate).set('highValue', updatedEndDate)));
  };
  const onChangeEndDate = newEndDate => {
    const updatedEndDate = Object.assign({}, newEndDate, {
      offsetYear: getOffsetEndDateYear({
        endDate: newEndDate,
        startDate
      })
    });
    onChange(syntheticEvent(condition.set('highValue', updatedEndDate)));
  };
  const AnniversaryRangeInputWrapper = useOnePanel ? SinglePanelAnniversaryRangeInputWrapper : DoublePanelAnniversaryRangeInputWrapper;
  const AnniversaryDateInputWrapper = useOnePanel ? SinglePanelAnniversaryDateInputWrapper : 'div';
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsxs(AnniversaryRangeInputWrapper, {
      children: [/*#__PURE__*/_jsx(AnniversaryDateInputWrapper, {
        size: width.size,
        children: /*#__PURE__*/_jsx(AnniversaryDateInput, {
          value: startDate,
          onChange: onChangeStartDate,
          onBlur: onBlur,
          inputUse: inputUse
        })
      }), /*#__PURE__*/_jsx(ToSeparator, {
        children: I18n.text('ui.dateRange.to')
      }), /*#__PURE__*/_jsx(AnniversaryDateInputWrapper, {
        size: width.size,
        children: /*#__PURE__*/_jsx(AnniversaryDateInput, {
          value: endDate,
          onChange: onChangeEndDate,
          onBlur: onBlur,
          inputUse: inputUse
        })
      })]
    })
  });
};
export default FilterOperatorDateRangeInputMomentAnniversary;